export default __webpack_public_path__ + "static/media/small_icon_gray.ef6027bf.svg";